import React, { ReactNode } from 'react';
import styles from './assets/districts-screen.module.scss';
import classNames from 'classnames';
import DistrictsGrid from './components/DistrictsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreateDistrictButton from './components/CreateDistrictButton';
import AdminLayout from 'src/components/layout/RoleLayout';
import { IDistrict } from 'src/types/district';
import Loader from '../../../../../../components/Loader';

export interface StateProps {
    data: Paginated<IDistrict>;
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class DistrictsList extends React.Component<Props> {
    //componentDidMount() {}

    public render(): ReactNode {
        const { data, getData, inProgress } = this.props;

        return (
            <AdminLayout>
                <div className={`${classNames(styles.pageHeading)} pageHeading`}>
                    <h2 className={`${classNames(styles.pageHeadingTitle)} pageHeadingTitle`}>
                        DISTRICTS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    <CreateDistrictButton />
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <DistrictsGrid data={data} getData={getData} />
                </div>
            </AdminLayout>
        );
    }
}

export default DistrictsList;
